import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import type { FC } from "react";
import ProviderTermsAndConditionsContent from "./ProviderTermsAndConditionsContent";

interface Props {
  readonly open: boolean;
  readonly providerId: string | undefined;
  readonly onClose: () => void;
}

const ProviderTermsAndConditionsDialog: FC<Props> = ({ open, providerId, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
    <DialogTitle>Terms & conditions</DialogTitle>
    <DialogContent>
      {providerId && <ProviderTermsAndConditionsContent providerId={providerId} enabled={open} />}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Zamknij</Button>
    </DialogActions>
  </Dialog>
);

export default ProviderTermsAndConditionsDialog;
